import { render } from "./TermsConditionsText.vue?vue&type=template&id=3e199116&scoped=true"
import script from "./TermsConditionsText.vue?vue&type=script&lang=js"
export * from "./TermsConditionsText.vue?vue&type=script&lang=js"

import "./TermsConditionsText.vue?vue&type=style&index=0&id=3e199116&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e199116"]])

export default __exports__